var content = require("!!../../../node_modules/.pnpm/css-loader@3.2.0_webpack@4.41.0/node_modules/css-loader/dist/cjs.js??ref--5-1!../../../node_modules/.pnpm/postcss-loader@3.0.0/node_modules/postcss-loader/src/index.js??ref--5-2!../../../node_modules/.pnpm/sass-loader@8.0.0_sass@1.86.3_webpack@4.41.0/node_modules/sass-loader/dist/cjs.js??ref--5-3!./style.scss");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {}

options.insert = "head";
options.singleton = false;

var update = require("!../../../node_modules/.pnpm/style-loader@1.0.0_webpack@4.41.0/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}
